export default __webpack_public_path__ + "locales/ro/About.json?hash=8ae3914284934e8fcdf31ecc3b8e899c";